<template>
  <CRow class="no-gutters">
    <CCol sm="8">
      <CCarousel
        class="image-carousel"
        indicators
        animate
        :interval="7000"
        height="100%"
      >
        <CCarouselItem>
          <img class="carousel-items img-banner" :src="Banner1" />
        </CCarouselItem>
        <CCarouselItem>
          <img class="carousel-items img-banner" :src="Banner2" />
        </CCarouselItem>
        <CCarouselItem>
          <img class="carousel-items img-banner" :src="Banner3" />
        </CCarouselItem>
        <CCarouselItem>
          <img class="carousel-items img-banner" :src="Banner4" />
        </CCarouselItem>
      </CCarousel>
    </CCol>
    <CCol sm="4" class="pl-5 pr-5">
      <CAlert
        style="position: absolute; width: 80%"
        color="danger"
        :show.sync="currentAlertCounter"
        closeButton
      >
        {{ errorMessage }}
      </CAlert>
      <div class="input-area mt-5">
        <div class="row no-gutters">
          <div class="col-md-12 text-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="193"
              height="121"
              viewBox="0 0 193 121"
              fill="none"
            >
              <path
                d="M51.7352 6.21723C44.4978 4.67658 40.2633 6.69075 39.0508 7.89042L54.8191 69.9744C54.8191 69.9744 59.3868 67.609 67.2367 68.744C75.7462 69.9744 86.5548 75.6871 90.0577 76.6089C93.7322 77.5759 98.1996 77.5224 107.758 74.1087C117.115 70.7671 134.104 80.4619 142.498 85.3454L139.298 72.2118C138.069 64.2673 135.158 45.3089 133.344 33.0308C131.529 20.7526 121.167 20.3581 116.212 21.6957C107.637 23.9554 88.4604 27.1191 80.3587 21.6957C70.2316 14.9164 60.7821 8.14304 51.7352 6.21723Z"
                fill="white"
              />
              <path
                d="M48.97 89.976L46.8141 86.8961L36.1509 7.03265H37.8945L48.97 89.976Z"
                fill="#2F20D2"
              />
              <path
                d="M53.8448 100.29H52.4262L36.9106 7.09341L37.8722 6.9575L53.8448 100.29Z"
                fill="#2F20D2"
              />
              <path
                d="M63.5223 100.01L62.4122 101.692L36.8511 7.14218L38.6833 6.83099L63.5223 100.01Z"
                fill="#2F20D2"
              />
              <path
                d="M40.7098 3.64397C40.7098 5.65648 39.0784 7.28794 37.0658 7.28794C35.0533 7.28794 33.4219 5.65648 33.4219 3.64397C33.4219 1.63146 35.0533 0 37.0658 0C39.0784 0 40.7098 1.63146 40.7098 3.64397ZM35.6487 3.64397C35.6487 4.42664 36.2832 5.06111 37.0658 5.06111C37.8485 5.06111 38.483 4.42664 38.483 3.64397C38.483 2.8613 37.8485 2.22683 37.0658 2.22683C36.2832 2.22683 35.6487 2.8613 35.6487 3.64397Z"
                fill="#2F20D2"
              />
              <path
                d="M58.1568 13.7787C47.8473 4.92186 41.4061 5.94069 39.4741 7.55721L54.8991 69.9546L62.1733 68.3165C65.1202 66.1957 72.1387 61.1301 76.638 57.8342C82.262 53.7142 87.2945 45.5253 90.1095 45.6706C92.9245 45.8159 98.2186 53.7796 103.319 58.9459C107.4 63.0789 118.055 71.6109 122.873 75.3602L142.361 85.0388L135.358 47.9393C135.046 40.7309 133.077 25.8338 127.687 23.9125C120.951 21.5108 103.437 32.1132 98.7506 36.0379C94.0644 39.9625 90.1095 41.4394 87.9138 41.2512C86.2737 41.1106 83.4815 38.459 82.2905 37.1508C78.5416 33.0504 68.4663 22.6355 58.1568 13.7787Z"
                fill="#EB1D15"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M39.8428 8.13902L55.3012 69.0026C55.3369 68.989 55.3738 68.9751 55.4118 68.9611C55.9922 68.7461 56.8415 68.4759 57.9394 68.2435C60.1361 67.7785 63.3243 67.4655 67.3388 68.0459C71.6841 68.6742 76.5812 70.4388 80.7899 72.1381C82.2503 72.7277 83.6396 73.3144 84.8972 73.8455C85.4536 74.0805 85.9842 74.3046 86.4838 74.5132C88.1345 75.2026 89.4192 75.7112 90.2384 75.9267C93.715 76.8416 98.0233 76.8369 107.522 73.4444C110.02 72.5524 112.971 72.5469 116.072 73.0725C119.18 73.5994 122.495 74.6698 125.755 75.9888C131.57 78.3419 137.279 81.5155 141.423 83.906L138.614 72.3787C138.609 72.3592 138.605 72.3394 138.602 72.3195C137.374 64.3749 134.462 45.4145 132.647 33.1338C131.773 27.2216 128.877 24.2698 125.68 22.906C122.428 21.5186 118.768 21.7364 116.397 22.3765L116.393 22.3776C112.069 23.517 105.084 24.8823 98.1494 25.2809C94.6814 25.4803 91.2076 25.4391 88.076 24.9999C84.9528 24.5618 82.1172 23.7207 79.9675 22.2817C79.0562 21.6716 78.1516 21.0625 77.2534 20.4576C73.1467 17.6922 69.1723 15.0159 65.2872 12.7453C60.5535 9.97862 56.0051 7.84696 51.5896 6.90702C45.0714 5.51948 41.1944 7.11029 39.8428 8.13902ZM55.1442 70.6009C55.144 70.601 55.1439 70.601 55.1438 70.6011C55.1437 70.6011 55.1437 70.6011 55.1437 70.6011C54.9528 70.6996 54.7274 70.7057 54.5314 70.6177C54.3351 70.5295 54.1897 70.3565 54.1368 70.1479L38.3684 8.06399C38.3069 7.82165 38.3782 7.56484 38.5559 7.38899C39.9874 5.9727 44.492 3.95394 51.8833 5.52734C56.5146 6.51321 61.2145 8.73111 65.999 11.5274C69.9267 13.823 73.9471 16.5304 78.0552 19.2968C78.95 19.8995 79.8491 20.5049 80.7522 21.1095C82.6534 22.3822 85.253 23.1795 88.2719 23.6029C91.2825 24.0252 94.6577 24.0688 98.0684 23.8727C104.89 23.4805 111.78 22.1344 116.032 21.0141C118.615 20.3172 122.613 20.064 126.233 21.6086C129.91 23.1772 133.102 26.5617 134.043 32.9276C135.855 45.1879 138.76 64.1124 139.992 72.0742L143.184 85.1784C143.251 85.4532 143.148 85.7413 142.921 85.9105C142.695 86.0797 142.389 86.0972 142.144 85.955C137.946 83.5125 131.64 79.8918 125.226 77.2964C122.019 75.9989 118.808 74.967 115.836 74.4633C112.858 73.9584 110.177 73.9941 107.996 74.7729C98.3784 78.2079 93.7519 78.31 89.8794 77.2909C88.9472 77.0456 87.5672 76.4944 85.9402 75.8149C85.4312 75.6023 84.8952 75.376 84.3358 75.1397C83.0827 74.6105 81.7117 74.0315 80.2618 73.4461C76.0633 71.751 71.3013 70.0441 67.137 69.442C63.3016 68.8875 60.2811 69.1896 58.2315 69.6235C57.2062 69.8406 56.4229 70.0908 55.9016 70.2839C55.641 70.3804 55.4459 70.4626 55.3189 70.5192C55.2554 70.5475 55.2089 70.5693 55.1798 70.5834C55.1652 70.5904 55.155 70.5955 55.1491 70.5984L55.1447 70.6006C55.1445 70.6007 55.1443 70.6008 55.1442 70.6009Z"
                fill="#2F20D2"
              />
              <path
                d="M168.698 88.8581H175.135L180.603 105.091L185.942 88.8581H192.207L184.134 110.86L182.691 114.843C182.16 116.178 181.651 117.197 181.163 117.9C180.689 118.603 180.137 119.17 179.505 119.601C178.888 120.046 178.12 120.39 177.202 120.634C176.297 120.878 175.271 121 174.123 121C172.96 121 171.819 120.878 170.7 120.634L170.162 115.898C171.109 116.084 171.963 116.178 172.724 116.178C174.13 116.178 175.171 115.762 175.845 114.929C176.52 114.111 177.036 113.063 177.395 111.786L168.698 88.8581Z"
                fill="#2F20D2"
              />
              <path
                d="M159.289 111.721V80.1604H165.339V111.721H159.289Z"
                fill="#2F20D2"
              />
              <path
                d="M147.018 85.7578V80.1604H153.068V85.7578H147.018ZM147.018 111.721V88.8579H153.068V111.721H147.018Z"
                fill="#2F20D2"
              />
              <path
                d="M126.997 95.8334L121.507 94.843C122.124 92.6328 123.186 90.9966 124.693 89.9345C126.2 88.8725 128.439 88.3414 131.41 88.3414C134.108 88.3414 136.118 88.6644 137.438 89.3102C138.759 89.9417 139.684 90.7526 140.215 91.7429C140.761 92.7189 141.033 94.5201 141.033 97.1466L140.969 104.208C140.969 106.217 141.062 107.703 141.249 108.664C141.45 109.612 141.816 110.631 142.347 111.721H136.362C136.204 111.32 136.01 110.724 135.781 109.935C135.68 109.576 135.608 109.339 135.565 109.224C134.532 110.229 133.427 110.982 132.25 111.485C131.073 111.987 129.817 112.238 128.482 112.238C126.129 112.238 124.27 111.599 122.906 110.322C121.557 109.045 120.883 107.43 120.883 105.478C120.883 104.186 121.191 103.038 121.809 102.034C122.426 101.015 123.287 100.24 124.392 99.7085C125.511 99.1631 127.119 98.6895 129.214 98.2876C132.042 97.7566 134.001 97.2614 135.092 96.8021V96.1993C135.092 95.0368 134.805 94.2115 134.23 93.7236C133.656 93.2212 132.573 92.9701 130.98 92.9701C129.903 92.9701 129.064 93.1854 128.461 93.6159C127.858 94.0321 127.37 94.7713 126.997 95.8334ZM135.092 100.742C134.317 101 133.089 101.309 131.41 101.668C129.731 102.026 128.633 102.378 128.116 102.722C127.327 103.282 126.932 103.993 126.932 104.854C126.932 105.701 127.248 106.433 127.88 107.05C128.511 107.667 129.315 107.975 130.291 107.975C131.382 107.975 132.422 107.617 133.412 106.899C134.144 106.354 134.625 105.686 134.855 104.897C135.013 104.38 135.092 103.397 135.092 101.947V100.742Z"
                fill="#2F20D2"
              />
              <path
                d="M90.6353 80.1604H102.282C104.909 80.1604 106.911 80.3613 108.289 80.7632C110.14 81.3086 111.726 82.2774 113.046 83.6696C114.367 85.0617 115.371 86.7697 116.06 88.7933C116.749 90.8027 117.094 93.2856 117.094 96.2422C117.094 98.84 116.771 101.079 116.125 102.959C115.336 105.255 114.209 107.114 112.745 108.535C111.64 109.611 110.147 110.451 108.267 111.054C106.861 111.499 104.98 111.721 102.627 111.721H90.6353V80.1604ZM97.0077 85.4995V106.404H101.765C103.545 106.404 104.83 106.303 105.619 106.102C106.652 105.844 107.506 105.406 108.181 104.789C108.87 104.172 109.43 103.16 109.86 101.753C110.291 100.333 110.506 98.4022 110.506 95.9623C110.506 93.5224 110.291 91.6494 109.86 90.3434C109.43 89.0373 108.827 88.0183 108.052 87.2863C107.277 86.5544 106.294 86.0592 105.102 85.8009C104.213 85.5999 102.469 85.4995 99.871 85.4995H97.0077Z"
                fill="#2F20D2"
              />
              <path
                d="M63.0998 113.228L70.0104 114.068C70.1252 114.872 70.3908 115.424 70.807 115.726C71.3811 116.156 72.2853 116.372 73.5196 116.372C75.0983 116.372 76.2824 116.135 77.0718 115.661C77.6028 115.345 78.0047 114.836 78.2774 114.133C78.4639 113.63 78.5572 112.705 78.5572 111.355V108.018C76.7488 110.487 74.4668 111.721 71.7112 111.721C68.6398 111.721 66.2071 110.422 64.413 107.825C63.0065 105.772 62.3032 103.218 62.3032 100.161C62.3032 96.3285 63.2218 93.4006 65.0589 91.377C66.9103 89.3533 69.2067 88.3414 71.948 88.3414C74.7754 88.3414 77.1076 89.5829 78.9447 92.0659V88.8581H84.6067V109.375C84.6067 112.073 84.3843 114.09 83.9394 115.424C83.4944 116.759 82.8701 117.807 82.0664 118.567C81.2626 119.328 80.1862 119.924 78.8371 120.354C77.5023 120.785 75.8088 121 73.7564 121C69.8813 121 67.1328 120.333 65.511 118.998C63.8892 117.678 63.0782 115.998 63.0782 113.96C63.0782 113.759 63.0854 113.515 63.0998 113.228ZM68.5034 99.8161C68.5034 102.242 68.9699 104.021 69.9028 105.155C70.85 106.275 72.0126 106.834 73.3904 106.834C74.8687 106.834 76.1173 106.26 77.1364 105.112C78.1554 103.95 78.6649 102.234 78.6649 99.9668C78.6649 97.5987 78.1769 95.8405 77.2009 94.6923C76.225 93.5442 74.9907 92.9701 73.498 92.9701C72.0485 92.9701 70.85 93.537 69.9028 94.6708C68.9699 95.7903 68.5034 97.5054 68.5034 99.8161Z"
                fill="#2F20D2"
              />
              <path
                d="M60.3007 111.721H53.3686L50.6129 104.552H37.9972L35.3923 111.721H28.6323L40.9251 80.1604H47.6635L60.3007 111.721ZM48.5677 99.2347L44.219 87.5232L39.9563 99.2347H48.5677Z"
                fill="#2F20D2"
              />
              <path
                d="M0 80.1604H12.6157C15.113 80.1604 16.9716 80.2681 18.1916 80.4834C19.4259 80.6843 20.5238 81.1149 21.4854 81.7751C22.4614 82.4353 23.2723 83.318 23.9182 84.4231C24.564 85.5139 24.8869 86.741 24.8869 88.1045C24.8869 89.5827 24.4851 90.939 23.6813 92.1733C22.892 93.4076 21.8155 94.3334 20.4521 94.9505C22.3753 95.5103 23.8536 96.4647 24.8869 97.8138C25.9203 99.1629 26.437 100.749 26.437 102.572C26.437 104.007 26.0997 105.406 25.4252 106.77C24.7649 108.119 23.8536 109.202 22.691 110.02C21.5428 110.824 20.122 111.319 18.4284 111.506C17.3663 111.621 14.8044 111.693 10.7427 111.721H0V80.1604ZM6.37243 85.4134V92.7116H10.549C13.0319 92.7116 14.5748 92.6757 15.1776 92.6039C16.2684 92.4747 17.1223 92.1016 17.7395 91.4844C18.371 90.8529 18.6867 90.0277 18.6867 89.0087C18.6867 88.0327 18.414 87.2433 17.8687 86.6405C17.3376 86.0234 16.5411 85.6502 15.479 85.521C14.8475 85.4493 13.0319 85.4134 10.0323 85.4134H6.37243ZM6.37243 97.9645V106.404H12.2712C14.5676 106.404 16.0244 106.339 16.6415 106.21C17.5888 106.038 18.3566 105.621 18.9451 104.961C19.5479 104.287 19.8493 103.39 19.8493 102.27C19.8493 101.323 19.6196 100.519 19.1604 99.859C18.7011 99.1988 18.0337 98.718 17.1582 98.4166C16.2971 98.1152 14.4169 97.9645 11.5177 97.9645H6.37243Z"
                fill="#2F20D2"
              />
            </svg>
          </div>
        </div>
        <div class="row no-gutters mt-5">
          <div class="col-md-12 text-center">
            <h5 style="color: #aeaeae; font-weight: 500">Powered by</h5>
          </div>
        </div>
        <div class="row no-gutters">
          <div class="col-md-12 text-center">
            <img :src="logos" width="135" height="60" />
          </div>
        </div>
        <div class="row no-gutters mt-5">
          <div v-if="!allowedSso" class="col-md-12">
            <h1 style="float: left">Log In</h1>
          </div>
          <div class="col-md-12 mt-1">
            <CAlert
              v-if="authError"
              v-bind:visible="authError"
              color="danger"
              class="mt-3"
              dismissible
              >{{ authError }}</CAlert
            >
          </div>
        </div>
        <div v-if="!allowedSso" class="row no-gutters pt-2">
          <div class="col-md-12">
            <label :class="labelEmailErr">Email</label>
            <input
              v-model="email"
              :class="classEmailErr"
              class="form-control rounded w-100"
              type="text"
            />
            <label
              style="position: absolute"
              v-if="errEmailShow == 'errEmailShow'"
              :class="errEmailShow"
              >Pastikan email valid</label
            >
            <label
              style="position: absolute"
              v-if="errEmailShow == 'not-error'"
              class="text-success"
              :class="errEmailShow"
              >Email valid
              <font-awesome-icon :icon="{ prefix: 'fas', iconName: 'check' }"
            /></label>
          </div>
        </div>
        <div v-if="!allowedSso" class="row no-gutters pt-4">
          <div class="col-md-12">
            <label :class="labelPassErr">Password</label>
            <div class="input-group">
              <input
                :type="typePassword"
                v-model="password"
                :class="classPassErr"
                class="form-control"
              />
              <div
                :class="classPassErr"
                class="input-group-append rounded-right"
              >
                <span
                  style="cursor: pointer"
                  @click="statusPassword()"
                  v-if="typePassword == 'password'"
                  class="input-group-text"
                  ><font-awesome-icon
                    :icon="{ prefix: 'fas', iconName: 'eye' }"
                /></span>
                <span
                  style="cursor: pointer"
                  @click="statusPassword()"
                  v-else
                  class="input-group-text"
                  ><font-awesome-icon
                    :icon="{ prefix: 'fas', iconName: 'eye-slash' }"
                /></span>
              </div>
            </div>
            <label
              style="position: absolute"
              v-if="errPassShow == 'errPassShow'"
              :class="errPassShow"
              >Pastikan password lebih dari 8 karakter</label
            >
            <label
              style="position: absolute"
              v-if="errPassShow == 'not-error'"
              class="text-success"
              :class="errPassShow"
              >Password valid
              <font-awesome-icon :icon="{ prefix: 'fas', iconName: 'check' }"
            /></label>
          </div>
        </div>
        <div class="row no-gutters mt-5">
          <div class="col-md-12">
            <CButton
              v-if="!allowedSso"
              @click="goLogin()"
              class="w-100 btn-primary"
            >
              <span v-if="loading == false">Log In</span>
              <CSpinner v-else color="default" size="sm" />
            </CButton>
            <CButton
              v-if="allowedSso"
              type="button"
              class="w-100 mt-2 btn btn-outline-primary ms-1"
              @click="loginWithSSO"
              :disabled="ssoProcessing || !allowedSso"
            >
              <span class="text-blue">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="icon icon-tabler icons-tabler-outline icon-tabler-shield-check"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path
                    d="M11.46 20.846a12 12 0 0 1 -7.96 -14.846a12 12 0 0 0 8.5 -3a12 12 0 0 0 8.5 3a12 12 0 0 1 -.09 7.06"
                  />
                  <path d="M15 19l2 2l4 -4" />
                </svg>
              </span>
              {{ ssoProcessing ? 'Redirecting...' : 'Sign in with SSO' }}
            </CButton>
          </div>
        </div>
        <div v-if="!allowedSso" class="row no-gutters mt-3">
          <div class="col-md-6">
            <CButton @click="loginGoogle" class="w-100 btn-light">
              <svg
                v-if="loadingGoogle == false"
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 18 18"
                aria-hidden="true"
              >
                <title>Google</title>
                <g fill="none" fill-rule="evenodd">
                  <path
                    fill="#4285F4"
                    d="M17.64 9.2045c0-.6381-.0573-1.2518-.1636-1.8409H9v3.4814h4.8436c-.2086 1.125-.8427 2.0782-1.7959 2.7164v2.2581h2.9087c1.7018-1.5668 2.6836-3.874 2.6836-6.615z"
                  ></path>
                  <path
                    fill="#34A853"
                    d="M9 18c2.43 0 4.4673-.806 5.9564-2.1805l-2.9087-2.2581c-.8059.54-1.8368.859-3.0477.859-2.344 0-4.3282-1.5831-5.036-3.7104H.9574v2.3318C2.4382 15.9832 5.4818 18 9 18z"
                  ></path>
                  <path
                    fill="#FBBC05"
                    d="M3.964 10.71c-.18-.54-.2822-1.1168-.2822-1.71s.1023-1.17.2823-1.71V4.9582H.9573A8.9965 8.9965 0 0 0 0 9c0 1.4523.3477 2.8268.9573 4.0418L3.964 10.71z"
                  ></path>
                  <path
                    fill="#EA4335"
                    d="M9 3.5795c1.3214 0 2.5077.4541 3.4405 1.346l2.5813-2.5814C13.4632.8918 11.426 0 9 0 5.4818 0 2.4382 2.0168.9573 4.9582L3.964 7.29C4.6718 5.1627 6.6559 3.5795 9 3.5795z"
                  ></path>
                </g>
              </svg>
              <span v-if="loadingGoogle == false"> Sign In via Google</span>
              <CSpinner
                v-if="loadingGoogle == true"
                color="default"
                size="sm"
              />
            </CButton>
          </div>
          <div class="col-md-6">
            <CButton @click="loginPhoneNumber" class="w-100 btn-light">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                fill="currentColor"
                class="bi bi-phone"
                viewBox="0 0 16 16"
              >
                <path
                  d="M11 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h6zM5 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H5z"
                />
                <path d="M8 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2z" />
              </svg>
              <span> Sign In via Phone Number</span>
            </CButton>
          </div>
        </div>
        <div v-if="!allowedSso" class="row no-gutters mt-5">
          <div class="col-md-12">
            <h6 class="text-center">
              Don't have account? <span class="text-primary">Sign up</span>
            </h6>
          </div>
        </div>
        <div v-if="!allowedSso" class="row no-gutters mt-1">
          <div class="col-md-12">
            <h6 class="text-center">
              <span class="text-primary">Forgot password?</span>
            </h6>
          </div>
        </div>
      </div>
    </CCol>
    <div v-if="checkingSsoHealth" class="loading-mask">
      <div class="spinner-border text-light" role="status">
        <!-- <span class="visually-hidden">Checking server...</span> -->
      </div>
      <p class="text-white mt-3 fw-semibold">Checking IAM Server...</p>
    </div>
    <PopUpPhoneNumber
      @checkPhone="checkPhone"
      @checkCode="checkCode"
      ref="popupPhoneNumber"
    />
    <PopUpForgot
      @checkPhone="checkPhone"
      @checkCode="checkCode"
      ref="popUpForgot"
    />
    <div id="recaptcha-container"></div>

    <!-- Loading Mask Overlay -->
  </CRow>
</template>

<script>
import { auth } from './firebase.js';
import { RecaptchaVerifier, signInWithPhoneNumber } from 'firebase/auth';
import PopUpPhoneNumber from './PopUpPhoneNumber.vue';
import PopUpForgot from './PopUpForgot.vue';
import { AuthLogin } from '../../service/Auth';
import { DataApi } from '@/service/DataApi';
import { config } from '@/utils/config.js';

export default {
  components: {
    PopUpPhoneNumber,
    PopUpForgot,
  },
  name: 'Login',
  data() {
    return {
      logos: require('../../assets/image/logos.svg'),
      bagLogos: require('../../assets/image/LOGO_SVG.svg'),
      Banner1: require('../../assets/image/Banner_1.svg'),
      Banner2: require('../../assets/image/Banner_2.svg'),
      Banner3: require('../../assets/image/Banner_3.svg'),
      Banner4: require('../../assets/image/Banner_4.svg'),
      loading: '',
      loadingGoogle: '',
      email: '',
      password: '',
      typePassword: 'password',
      classEmailErr: '',
      labelEmailErr: '',
      errEmailShow: '',
      classPassErr: '',
      labelPassErr: '',
      errPassShow: '',
      emailvalid: false,
      passwordvalid: false,
      errorMessage: '',
      roles: '',
      rolesMenu: [],
      menus: [],
      finded: [],
      parentId: [],
      parentMenus: [],
      currentAlertCounter: 0,
      authError: null,
      isAuthError: false,
      processing: false,
      ssoProcessing: false,
      allowedSso: config.ssoConfig.allowedSso,
      ssoConfig: config.ssoConfig,
      checkingSsoHealth: false,
    };
  },
  watch: {
    email() {
      this.validateEmail();
    },
    password() {
      this.validatePass();
    },
  },
  beforeCreate() {
    if (localStorage.getItem('token')) {
      this.$router.replace('/dashboard');
    }
  },
  methods: {
    async checkSsoHealth() {
      this.checkingSsoHealth = true;
      try {
        const response = await fetch(this.ssoConfig.ssoHealth, {
          method: 'GET',
        });

        if (response.ok) {
          this.allowedSso = true;
        } else {
          this.allowedSso = false;
          this.errorMessage =
            'Server IAM is down, please enter email and password to login.';
        }
      } catch (error) {
        this.allowedSso = false;
        this.errorMessage =
          'Server IAM is down, please enter email and password to login.';
        console.error('❌ SSO health check failed:', error);
      } finally {
        this.checkingSsoHealth = false;
      }
    },
    async loginGoogle() {
      const googleUser = await this.$gAuth.signIn();
      let profile = googleUser.getBasicProfile();
      this.loadingGoogle = true;
      this.loading = false;
      if (profile.getEmail() == undefined) {
        this.errorMessage = 'CANNOT GET DATA FROM GOOGLE. PLEASE TRY AGAIN.';
        this.currentAlertCounter = 5;
        this.loadingGoogle = false;
      } else {
        let usernames = profile.getEmail();
        let payload = {
          appVersion: '1',
          deviceId: 'web',
          deviceType: 'web',
          deviceVersion: '1.0',
          email: profile.getEmail(),
          name: profile.getName(),
          username: usernames.split('@gmail')[0],
          usernameBy: '2',
        };
        const config = {
          headers: {
            'Content-Type': 'application/json',
          },
        };
        AuthLogin.post('user/checkpass', payload, config)
          .then((res) => {
            let response = res.data.data.Data2;
            if (res.data.success == true) {
              this.loadingGoogle = false;
              localStorage.setItem('token', response.token);
              localStorage.setItem('urlFoto', profile.getImageUrl());
              localStorage.setItem('login', 'google');
              this.updateNotif();
              let dataMenu = response.role.menus;
              let menu = [];
              var i;
              for (i = 0; i < dataMenu.length; i++) {
                if (dataMenu[i].childs != undefined) {
                  var j = 0;
                  for (j = 0; j < dataMenu[i].childs.length; j++) {
                    let hasChild = dataMenu[i].childs;
                    if (hasChild[j].childs != undefined) {
                      var k = 0;
                      for (k = 0; k < hasChild[j].childs.length; k++) {
                        let hasGrandChild = hasChild[j].childs;
                        menu.push(hasGrandChild[k].name);
                      }
                    } else {
                      menu.push(hasChild[j].name);
                    }
                  }
                } else {
                  menu.push(dataMenu[i].name);
                }
              }
              localStorage.setItem('menus', menu);
              this.getSidebar(dataMenu);
              this.$router.replace('/dashboard');
              //
            } else {
              this.loadingGoogle = false;
              this.errorMessage = res.data.message;
              this.currentAlertCounter = 5;
            }
            this.$store.state.messageAuth = false;
          })
          .catch((err) => {
            console.log(err);
            this.loadingGoogle = false;
            this.errorMessage = 'Maaf, Terjadi kesalahan.';
            this.currentAlertCounter = 5;
          });
      }
    },
    goLogin() {
      if (this.emailvalid == false) {
        if (this.passwordvalid == false) {
          this.errorMessage = 'Email and Password Not Valid !';
          this.currentAlertCounter = 5;
        } else {
          this.errorMessage = 'Email Not Valid !';
          this.currentAlertCounter = 5;
        }
      } else {
        if (this.passwordvalid == false) {
          this.errorMessage = 'Password Not Valid !';
          this.currentAlertCounter = 5;
        } else {
          this.onLogin();
        }
      }
    },
    onLogin() {
      this.loading = true;
      this.loadingGoogle = false;
      let data = {
        email: this.email,
        password: this.password,
        type: 1,
      };
      const config = {
        headers: {
          'Content-Type': 'application/json',
        },
      };
      /**
       * Set TOKEN to LocalStorage
       */
      AuthLogin.post('user/login', data, config).then((response) => {
        let res = response.data;
        if (res.success == true) {
          this.loading = false;
          localStorage.setItem('token', res.data.token);
          localStorage.setItem('urlFoto', res.data.urlFoto);
          localStorage.setItem('login', 'non-google');
          localStorage.setItem('loginType', res.data.loginType);
          this.updateNotif();
          let dataMenu = res.data.role.menus;
          let menu = [];
          var i;
          for (i = 0; i < dataMenu.length; i++) {
            if (dataMenu[i].childs != undefined) {
              var j = 0;
              for (j = 0; j < dataMenu[i].childs.length; j++) {
                let hasChild = dataMenu[i].childs;
                if (hasChild[j].childs != undefined) {
                  var k = 0;
                  for (k = 0; k < hasChild[j].childs.length; k++) {
                    let hasGrandChild = hasChild[j].childs;
                    menu.push(hasGrandChild[k].name);
                  }
                } else {
                  menu.push(hasChild[j].name);
                }
              }
            } else {
              menu.push(dataMenu[i].name);
            }
          }
          localStorage.setItem('menus', menu);
          this.getSidebar(dataMenu);
          let base = localStorage.getItem('prevUrl');
          if (base === '/') {
            this.$router.replace('/dashboard');
          } else {
            this.$router.replace(base);
          }
        } else {
          this.errorMessage = res.message;
          this.currentAlertCounter = 5;
          this.loading = false;
        }
        this.$store.state.messageAuth = false;
      });
    },
    statusPassword() {
      if (this.typePassword == 'password') {
        this.typePassword = 'text';
      } else {
        this.typePassword = 'password';
      }
    },
    validateEmail() {
      const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      const Regex = re.test(String(this.email).toLowerCase());
      if (Regex == false) {
        this.classEmailErr = 'classEmailErr';
        this.labelEmailErr = 'labelEmailErr';
        this.errEmailShow = 'errEmailShow';
        this.emailvalid = false;
      } else {
        this.classEmailErr = 'classEmailSuccess';
        this.labelEmailErr = '';
        this.errEmailShow = 'not-error';
        this.emailvalid = true;
      }
    },
    validatePass() {
      if (this.password.length < 8) {
        this.classPassErr = 'classPassErr';
        this.labelPassErr = 'labelPassErr';
        this.errPassShow = 'errPassShow';
        this.passwordvalid = false;
      } else {
        this.classPassErr = 'classPassSuccess';
        this.labelPassErr = '';
        this.errPassShow = 'not-error';
        this.passwordvalid = true;
      }
    },
    getSidebar(menu) {
      var i = 0;
      for (i = 0; i < menu.length; i++) {
        if (
          menu[i].childs == null ||
          menu[i].childs == 0 ||
          menu[i].childs == 'null' ||
          menu[i].childs == '' ||
          menu[i].childs == undefined
        ) {
          let onPush = {
            name: menu[i].name,
            activeClass: 'not-active',
            to: menu[i].path,
            items: '',
          };
          this.menus.push(onPush);
        } else {
          var j = 0;
          let itemPush = [];
          let hasChild = menu[i].childs;
          for (j = 0; j < hasChild.length; j++) {
            if (
              hasChild[j].childs == null ||
              hasChild[j].childs == 0 ||
              hasChild[j].childs == 'null' ||
              hasChild[j].childs == '' ||
              hasChild[j].childs == undefined
            ) {
              let item = {
                name: hasChild[j].name,
                activeClass: 'not-active',
                to: hasChild[j].path,
                items: '',
              };
              itemPush.push(item);
            } else {
              var k = 0;
              let childPush = [];
              let hasGrandChild = hasChild[j].childs;
              for (k = 0; k < hasGrandChild.length; k++) {
                let li = {
                  name: hasGrandChild[k].name,
                  activeClass: 'not-active',
                  to: hasGrandChild[k].path,
                  items: '',
                };
                childPush.push(li);
              }
              let items = {
                id: hasChild[j].id,
                name: hasChild[j].name,
                rotate: 'rotateOff',
                status: false,
                items: childPush,
              };
              itemPush.push(items);
            }
          }
          let pushParentId = {
            id: menu[i].id,
            name: menu[i].name,
            rotate: 'rotateOff',
            status: false,
            items: itemPush,
          };
          this.parentId.push(pushParentId);
        }
      }
      var h = 0;
      for (h = 0; h < this.parentId.length; h++) {
        this.menus.push(this.parentId[h]);
      }
      localStorage.setItem('draftMenu', JSON.stringify(this.menus));
    },
    loginPhoneNumber() {
      this.$refs.popupPhoneNumber.isShown = true;
    },
    checkPhone(value) {
      let payload = {
        phone: value,
      };
      DataApi.post('user/checkphone', payload).then((res) => {
        let resp = res.data;
        if (resp.success == true) {
          if (resp.data.Data1.split('@@')[0] == 'Y') {
            // this.$refs.popupPhoneNumber.flagValidation = true
            this.checkFirebase(value);
          } else {
            this.$refs.popupPhoneNumber.flagValidation = false;
            this.$refs.popupPhoneNumber.alertMess =
              resp.data.Data1.split('@@')[1];
          }
        } else {
          this.$refs.popupPhoneNumber.alertMess = resp.message;
          this.$refs.popupPhoneNumber.flagValidation = false;
        }
      });
    },
    checkFirebase(value) {
      window.recaptchaVerifier = new RecaptchaVerifier(
        auth,
        'recaptcha-container',
        {
          size: 'invisible',
          callback: (response) => {
            // reCAPTCHA solved, allow signInWithPhoneNumber.
            // ...
          },
          'expired-callback': () => {
            // Response expired. Ask user to solve reCAPTCHA again.
            // ...
          },
        }
      );
      const appVerifier = window.recaptchaVerifier;
      this.$refs.popupPhoneNumber.loadingPhone = true;
      const phoneNumber = value.replace(/^0/, '+62');
      signInWithPhoneNumber(auth, phoneNumber, appVerifier)
        .then((confirmationResult) => {
          this.$refs.popupPhoneNumber.loadingPhone = false;
          // SMS sent. Prompt user to type the code from the message, then sign the
          // user in with confirmationResult.confirm(code).
          window.confirmationResult = confirmationResult;
          this.$refs.popupPhoneNumber.flagValidation = true;
          // ...
        })
        .catch((error) => {
          this.$refs.popupPhoneNumber.loadingPhone = false;
          this.$refs.popupPhoneNumber.alertMess = error.message;
          // Error; SMS not sent
          // ...
        });
    },
    checkCode(value) {
      this.$refs.popupPhoneNumber.loadingCode = true;
      confirmationResult
        .confirm(value)
        .then((result) => {
          this.$refs.popupPhoneNumber.loadingCode = false;
          this.goLoginPhoneNumber(this.$refs.popupPhoneNumber.phoneNumber);
          this.$refs.popupPhoneNumber.closeModal();
          // ...
        })
        .catch((error) => {
          this.$refs.popupPhoneNumber.loadingCode = false;
          this.$refs.popupPhoneNumber.alertMess = error.message;
          // User couldn't sign in (bad verification code?)
          // ...
        });
    },
    goLoginPhoneNumber(value) {
      let payload = {
        appVersion: '2',
        deviceId: 'web',
        deviceType: 'web',
        deviceVersion: '2.0',
        phone: value,
        usernameBy: '3',
      };
      const config = {
        headers: {
          'Content-Type': 'application/json',
        },
      };
      AuthLogin.post('user/checkotp', payload, config).then((res) => {
        let response = res.data.data.Data2;
        if (res.data.success == true) {
          this.loadingGoogle = false;
          localStorage.setItem('token', response.token);
          localStorage.setItem('urlFoto', response.urlFoto);
          localStorage.setItem('login', 'phone');
          this.updateNotif();
          let dataMenu = response.role.menus;
          let menu = [];
          var i;
          for (i = 0; i < dataMenu.length; i++) {
            if (dataMenu[i].childs != undefined) {
              var j = 0;
              for (j = 0; j < dataMenu[i].childs.length; j++) {
                let hasChild = dataMenu[i].childs;
                if (hasChild[j].childs != undefined) {
                  var k = 0;
                  for (k = 0; k < hasChild[j].childs.length; k++) {
                    let hasGrandChild = hasChild[j].childs;
                    menu.push(hasGrandChild[k].name);
                  }
                } else {
                  menu.push(hasChild[j].name);
                }
              }
            } else {
              menu.push(dataMenu[i].name);
            }
          }
          localStorage.setItem('menus', menu);
          this.getSidebar(dataMenu);
          this.$router.replace('/dashboard');
          //
        } else {
          this.loadingGoogle = false;
          this.errorMessage = res.data.message;
          this.currentAlertCounter = 5;
        }
        this.$store.state.messageAuth = false;
      });
    },
    /**
     * notif
     */
    updateNotif() {
      DataApi.post('surat/notification').then((res) => {
        localStorage.setItem('notif', JSON.stringify(res.data.data));
      });
    },
    forgotPass() {
      this.$refs.popUpForgot.isShown = true;
    },
    async loginWithSSO() {
      try {
        this.ssoProcessing = true;
        // const ssoUrl = new URL(this.ssoConfig.authUrl);
        // ssoUrl.searchParams.append(
        //   'response_type',
        //   this.ssoConfig.responseType
        // );
        // ssoUrl.searchParams.append('client_id', this.ssoConfig.clientId);
        // ssoUrl.searchParams.append('scope', this.ssoConfig.scope);
        // ssoUrl.searchParams.append('redirect_uri', this.ssoConfig.redirectUri);
      const response = await fetch(`${config.API_BASE_URL}/user/get-authorized-url?clientId=${this.ssoConfig.clientId}&redirectUrl=${this.ssoConfig.redirectUri}`);
      const data = await response.json();
      if(response.ok) {
        // Redirect to SSO provider
        window.location.href = data.data;
      } else {
        throw new Error(data.message);
      }
      } catch (error) {
        console.error('SSO login error:', error);
        this.authError = 'Failed to initiate SSO login';
        this.ssoProcessing = false;
      }
    },
    async handleSSOCallback(code, state) {
      try {
        this.ssoProcessing = true;
        // Exchange code for tokens
        const response = await fetch(`${config.API_BASE_URL}/user/callback`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            code: code,
            state: state,
            redirectUri: this.ssoConfig.redirectUri,
            clientId: this.ssoConfig.clientId,
          }),
        });

        const data = await response.json();
        if (response.ok) {
          if (!data.data) {
            this.authError = data.message;
            return;
          }

          localStorage.setItem('token', data.data.token);
          localStorage.setItem('urlFoto', data.data.urlFoto);
          localStorage.setItem('login', 'non-google');
          localStorage.setItem('loginType', data.data.loginType);
          this.updateNotif();
          let dataMenu = data.data.role.menus;
          let menu = [];
          var i;
          for (i = 0; i < dataMenu.length; i++) {
            if (dataMenu[i].childs != undefined) {
              var j = 0;
              for (j = 0; j < dataMenu[i].childs.length; j++) {
                let hasChild = dataMenu[i].childs;
                if (hasChild[j].childs != undefined) {
                  var k = 0;
                  for (k = 0; k < hasChild[j].childs.length; k++) {
                    let hasGrandChild = hasChild[j].childs;
                    menu.push(hasGrandChild[k].name);
                  }
                } else {
                  menu.push(hasChild[j].name);
                }
              }
            } else {
              menu.push(dataMenu[i].name);
            }
          }
          localStorage.setItem('menus', menu);
          this.getSidebar(dataMenu);
          let base = localStorage.getItem('prevUrl');
          if (base === '/') {
            this.$router.replace('/dashboard');
          } else {
            this.$router.replace(base);
          }
        } else {
          console.log('Errrrror ', data);
          throw new Error(data.message || 'SSO callback failed');
        }
      } catch (error) {
        console.error('SSO callback error:', error);
        this.authError = error.message || 'SSO authentication failed';

        // Clear URL parameters
        window.history.replaceState(
          {},
          document.title,
          window.location.pathname
        );
      } finally {
        this.ssoProcessing = false;
      }
    },
  },
  mounted() {
    if (this.$store.state.messageAuth == true) {
      this.errorMessage =
        'Maaf, Session Anda Telah Habis. Silahkan Login Kembali.';
      this.currentAlertCounter = 5;
    }

    this.checkSsoHealth();

    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    const state = urlParams.get('state');
    const error = urlParams.get('error');
    if (error) {
      this.authError = `Anda tidak memiliki akses ke aplikasi ini.`;
      window.history.replaceState({}, document.title, window.location.pathname);
      return;
    }

    if (code) {
      this.handleSSOCallback(code, state);
    }
  },
};
</script>

<style lang="scss">
.classEmailErr,
.classPassErr {
  border: 1px solid red !important;
  box-shadow: none !important;
}
.labelEmailErr,
.labelPassErr,
.errEmailShow,
.errPassShow {
  color: red;
}

.classEmailSuccess,
.classPassSuccess {
  border: 1px solid #2eb85c !important;
  box-shadow: none !important;
}

@media (min-width: 400px) {
  .image-carousel {
    display: none;
  }
  // .carousel-items {
  //   width: 100%;
  //   height: 40vh;
  //   opacity: 0.8;
  // }
  // .input-area {
  //   padding: 64px;
  // }
}
@media (min-width: 576px) {
  .image-carousel {
    display: contents;
  }
  .carousel-items {
    width: 100%;
    height: 100vh;
  }
}
@media (min-width: 1200px) {
  .carousel-items {
    width: 100%;
    height: 100vh;
  }
}
.img-banner {
  width: 100%;
  object-fit: cover;
}

.loading-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.55);
  z-index: 1050;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  transition: opacity 0.3s ease;
}
</style>
